/**
 * @fileoverview gRPC-Web generated client stub for com.mu.logistic.api
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!

import * as grpcWeb from 'grpc-web';

import {
  CancelTaskByIdRequest,
  CancelTaskByIdResponse,
  CreateDeliveryRequest,
  CreateDeliveryResponse,
  CreateExpressRequest,
  CreateExpressResponse,
  EditDeliveryRequest,
  EditDeliveryResponse,
  GetAddressInGeologicRequest,
  GetAddressInGeologicResponse,
  GetCalculateRequest,
  GetCalculateResponse,
  GetCalculationDistanceRequest,
  GetCalculationDistanceResponse,
  GetCancellationRateRequest,
  GetCancellationRateResponse,
  GetCancellationTypesRequest,
  GetCancellationTypesResponse,
  GetCitiesRequest,
  GetCitiesResponse,
  GetDefaultDeclaredValueRequest,
  GetDefaultDeclaredValueResponse,
  GetDeliveryDetailByIdRequest,
  GetDeliveryDetailByIdResponse,
  GetDeliveryDetailByUUIDRequest,
  GetEvidencesByTaskIdRequest,
  GetEvidencesByTaskIdResponse,
  GetEvidencesZipByTaskIdResponse,
  GetExpressServicesRequest,
  GetExpressServicesResponse,
  GetExpressTaskHistoryRequest,
  GetExpressTaskHistoryResponse,
  GetOrderTypesRequest,
  GetOrderTypesResponse,
  GetPermissionsByUserIdRequest,
  GetPermissionsByUserIdResponse,
  GetRatebyTaskIdRequest,
  GetRatebyTaskIdResponse,
  GetResourcesByUserRequest,
  GetResourcesByUserResponse,
  ListCalculationDistanceRequest,
  ListCalculationDistanceResponse,
  OauthTokenRequest,
  OauthTokenResponse,
  PutCreateServiceRequest,
  PutCreateServiceResponse,
  RateTaskbyIdRequest,
  RateTaskbyIdResponse,
  SearchItemsRequest,
  SearchItemsResponse,
  SetDeliveryLogArmireneRequest,
  SetDeliveryLogArmireneResponse,
  UserTaskByIdRequest,
  UserTaskByIdResponse,
} from './delivery.api_pb';

export class DeliveryServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string };
  options_: null | { [index: string]: string };

  constructor(hostname: string, credentials: null | { [index: string]: string }, options: null | { [index: string]: string }) {
    if (!options) options = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoOauthToken = new grpcWeb.AbstractClientBase.MethodInfo(
    OauthTokenResponse,
    (request: OauthTokenRequest) => {
      return request.serializeBinary();
    },
    OauthTokenResponse.deserializeBinary
  );

  oauthToken(
    request: OauthTokenRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: OauthTokenResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.DeliveryService/OauthToken',
      request,
      metadata || {},
      this.methodInfoOauthToken,
      callback
    );
  }

  methodInfoUserTaskById = new grpcWeb.AbstractClientBase.MethodInfo(
    UserTaskByIdResponse,
    (request: UserTaskByIdRequest) => {
      return request.serializeBinary();
    },
    UserTaskByIdResponse.deserializeBinary
  );

  userTaskById(
    request: UserTaskByIdRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: UserTaskByIdResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.DeliveryService/UserTaskById',
      request,
      metadata || {},
      this.methodInfoUserTaskById,
      callback
    );
  }

  methodInfoGetPermissionsByUserId = new grpcWeb.AbstractClientBase.MethodInfo(
    GetPermissionsByUserIdResponse,
    (request: GetPermissionsByUserIdRequest) => {
      return request.serializeBinary();
    },
    GetPermissionsByUserIdResponse.deserializeBinary
  );

  getPermissionsByUserId(
    request: GetPermissionsByUserIdRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: GetPermissionsByUserIdResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.DeliveryService/GetPermissionsByUserId',
      request,
      metadata || {},
      this.methodInfoGetPermissionsByUserId,
      callback
    );
  }

  methodInfoGetCities = new grpcWeb.AbstractClientBase.MethodInfo(
    GetCitiesResponse,
    (request: GetCitiesRequest) => {
      return request.serializeBinary();
    },
    GetCitiesResponse.deserializeBinary
  );

  getCities(
    request: GetCitiesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: GetCitiesResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.DeliveryService/GetCities',
      request,
      metadata || {},
      this.methodInfoGetCities,
      callback
    );
  }

  methodInfoGetEvidencesByTaskId = new grpcWeb.AbstractClientBase.MethodInfo(
    GetEvidencesByTaskIdResponse,
    (request: GetEvidencesByTaskIdRequest) => {
      return request.serializeBinary();
    },
    GetEvidencesByTaskIdResponse.deserializeBinary
  );

  getEvidencesByTaskId(
    request: GetEvidencesByTaskIdRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: GetEvidencesByTaskIdResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.DeliveryService/GetEvidencesByTaskId',
      request,
      metadata || {},
      this.methodInfoGetEvidencesByTaskId,
      callback
    );
  }

  methodInfoRateTaskbyId = new grpcWeb.AbstractClientBase.MethodInfo(
    RateTaskbyIdResponse,
    (request: RateTaskbyIdRequest) => {
      return request.serializeBinary();
    },
    RateTaskbyIdResponse.deserializeBinary
  );

  rateTaskbyId(
    request: RateTaskbyIdRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: RateTaskbyIdResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.DeliveryService/RateTaskbyId',
      request,
      metadata || {},
      this.methodInfoRateTaskbyId,
      callback
    );
  }

  methodInfoGetRatebyTaskId = new grpcWeb.AbstractClientBase.MethodInfo(
    GetRatebyTaskIdResponse,
    (request: GetRatebyTaskIdRequest) => {
      return request.serializeBinary();
    },
    GetRatebyTaskIdResponse.deserializeBinary
  );

  getRatebyTaskId(
    request: GetRatebyTaskIdRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: GetRatebyTaskIdResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.DeliveryService/GetRatebyTaskId',
      request,
      metadata || {},
      this.methodInfoGetRatebyTaskId,
      callback
    );
  }

  methodInfoCancelTaskById = new grpcWeb.AbstractClientBase.MethodInfo(
    CancelTaskByIdResponse,
    (request: CancelTaskByIdRequest) => {
      return request.serializeBinary();
    },
    CancelTaskByIdResponse.deserializeBinary
  );

  cancelTaskById(
    request: CancelTaskByIdRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: CancelTaskByIdResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.DeliveryService/CancelTaskById',
      request,
      metadata || {},
      this.methodInfoCancelTaskById,
      callback
    );
  }

  methodInfoSearchItems = new grpcWeb.AbstractClientBase.MethodInfo(
    SearchItemsResponse,
    (request: SearchItemsRequest) => {
      return request.serializeBinary();
    },
    SearchItemsResponse.deserializeBinary
  );

  searchItems(
    request: SearchItemsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: SearchItemsResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.DeliveryService/SearchItems',
      request,
      metadata || {},
      this.methodInfoSearchItems,
      callback
    );
  }

  methodInfoGetResourcesByUser = new grpcWeb.AbstractClientBase.MethodInfo(
    GetResourcesByUserResponse,
    (request: GetResourcesByUserRequest) => {
      return request.serializeBinary();
    },
    GetResourcesByUserResponse.deserializeBinary
  );

  getResourcesByUser(
    request: GetResourcesByUserRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: GetResourcesByUserResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.DeliveryService/GetResourcesByUser',
      request,
      metadata || {},
      this.methodInfoGetResourcesByUser,
      callback
    );
  }

  methodInfoGetDeliveryDetailById = new grpcWeb.AbstractClientBase.MethodInfo(
    GetDeliveryDetailByIdResponse,
    (request: GetDeliveryDetailByIdRequest) => {
      return request.serializeBinary();
    },
    GetDeliveryDetailByIdResponse.deserializeBinary
  );

  getDeliveryDetailById(
    request: GetDeliveryDetailByIdRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: GetDeliveryDetailByIdResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.DeliveryService/GetDeliveryDetailById',
      request,
      metadata || {},
      this.methodInfoGetDeliveryDetailById,
      callback
    );
  }

  methodInfoGetCalculationDistance = new grpcWeb.AbstractClientBase.MethodInfo(
    GetCalculationDistanceResponse,
    (request: GetCalculationDistanceRequest) => {
      return request.serializeBinary();
    },
    GetCalculationDistanceResponse.deserializeBinary
  );

  getCalculationDistance(
    request: GetCalculationDistanceRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: GetCalculationDistanceResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.DeliveryService/GetCalculationDistance',
      request,
      metadata || {},
      this.methodInfoGetCalculationDistance,
      callback
    );
  }

  methodInfoGetAddressInGeologic = new grpcWeb.AbstractClientBase.MethodInfo(
    GetAddressInGeologicResponse,
    (request: GetAddressInGeologicRequest) => {
      return request.serializeBinary();
    },
    GetAddressInGeologicResponse.deserializeBinary
  );

  getAddressInGeologic(
    request: GetAddressInGeologicRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: GetAddressInGeologicResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.DeliveryService/GetAddressInGeologic',
      request,
      metadata || {},
      this.methodInfoGetAddressInGeologic,
      callback
    );
  }

  methodInfoPutCreateService = new grpcWeb.AbstractClientBase.MethodInfo(
    PutCreateServiceResponse,
    (request: PutCreateServiceRequest) => {
      return request.serializeBinary();
    },
    PutCreateServiceResponse.deserializeBinary
  );

  putCreateService(
    request: PutCreateServiceRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: PutCreateServiceResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.DeliveryService/PutCreateService',
      request,
      metadata || {},
      this.methodInfoPutCreateService,
      callback
    );
  }

  methodInfoCreateDelivery = new grpcWeb.AbstractClientBase.MethodInfo(
    CreateDeliveryResponse,
    (request: CreateDeliveryRequest) => {
      return request.serializeBinary();
    },
    CreateDeliveryResponse.deserializeBinary
  );

  createDelivery(
    request: CreateDeliveryRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: CreateDeliveryResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.DeliveryService/CreateDelivery',
      request,
      metadata || {},
      this.methodInfoCreateDelivery,
      callback
    );
  }

  methodInfoEditDelivery = new grpcWeb.AbstractClientBase.MethodInfo(
    EditDeliveryResponse,
    (request: EditDeliveryRequest) => {
      return request.serializeBinary();
    },
    EditDeliveryResponse.deserializeBinary
  );

  editDelivery(
    request: EditDeliveryRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: EditDeliveryResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.DeliveryService/EditDelivery',
      request,
      metadata || {},
      this.methodInfoEditDelivery,
      callback
    );
  }

  methodInfoGetCalculate = new grpcWeb.AbstractClientBase.MethodInfo(
    GetCalculateResponse,
    (request: GetCalculateRequest) => {
      return request.serializeBinary();
    },
    GetCalculateResponse.deserializeBinary
  );

  getCalculate(
    request: GetCalculateRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: GetCalculateResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.DeliveryService/GetCalculate',
      request,
      metadata || {},
      this.methodInfoGetCalculate,
      callback
    );
  }

  methodInfoGetListCalculationDistance = new grpcWeb.AbstractClientBase.MethodInfo(
    ListCalculationDistanceResponse,
    (request: ListCalculationDistanceRequest) => {
      return request.serializeBinary();
    },
    ListCalculationDistanceResponse.deserializeBinary
  );

  getListCalculationDistance(
    request: ListCalculationDistanceRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: ListCalculationDistanceResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.DeliveryService/GetListCalculationDistance',
      request,
      metadata || {},
      this.methodInfoGetListCalculationDistance,
      callback
    );
  }

  methodInfoCreateExpress = new grpcWeb.AbstractClientBase.MethodInfo(
    CreateExpressResponse,
    (request: CreateExpressRequest) => {
      return request.serializeBinary();
    },
    CreateExpressResponse.deserializeBinary
  );

  createExpress(
    request: CreateExpressRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: CreateExpressResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.DeliveryService/CreateExpress',
      request,
      metadata || {},
      this.methodInfoCreateExpress,
      callback
    );
  }

  methodInfoGetOrderTypes = new grpcWeb.AbstractClientBase.MethodInfo(
    GetOrderTypesResponse,
    (request: GetOrderTypesRequest) => {
      return request.serializeBinary();
    },
    GetOrderTypesResponse.deserializeBinary
  );

  getOrderTypes(
    request: GetOrderTypesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: GetOrderTypesResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.DeliveryService/GetOrderTypes',
      request,
      metadata || {},
      this.methodInfoGetOrderTypes,
      callback
    );
  }

  methodInfoGetExpressTaskHistory = new grpcWeb.AbstractClientBase.MethodInfo(
    GetExpressTaskHistoryResponse,
    (request: GetExpressTaskHistoryRequest) => {
      return request.serializeBinary();
    },
    GetExpressTaskHistoryResponse.deserializeBinary
  );

  getExpressTaskHistory(
    request: GetExpressTaskHistoryRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: GetExpressTaskHistoryResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.DeliveryService/GetExpressTaskHistory',
      request,
      metadata || {},
      this.methodInfoGetExpressTaskHistory,
      callback
    );
  }

  methodInfoGetExpressServices = new grpcWeb.AbstractClientBase.MethodInfo(
    GetExpressServicesResponse,
    (request: GetExpressServicesRequest) => {
      return request.serializeBinary();
    },
    GetExpressServicesResponse.deserializeBinary
  );

  getExpressServices(
    request: GetExpressServicesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: GetExpressServicesResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.DeliveryService/GetExpressServices',
      request,
      metadata || {},
      this.methodInfoGetExpressServices,
      callback
    );
  }

  methodInfoGetDefaultDeclaredValue = new grpcWeb.AbstractClientBase.MethodInfo(
    GetDefaultDeclaredValueResponse,
    (request: GetDefaultDeclaredValueRequest) => {
      return request.serializeBinary();
    },
    GetDefaultDeclaredValueResponse.deserializeBinary
  );

  getDefaultDeclaredValue(
    request: GetDefaultDeclaredValueRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: GetDefaultDeclaredValueResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.DeliveryService/GetDefaultDeclaredValue',
      request,
      metadata || {},
      this.methodInfoGetDefaultDeclaredValue,
      callback
    );
  }

  methodInfoGetCancellationTypes = new grpcWeb.AbstractClientBase.MethodInfo(
    GetCancellationTypesResponse,
    (request: GetCancellationTypesRequest) => {
      return request.serializeBinary();
    },
    GetCancellationTypesResponse.deserializeBinary
  );

  getCancellationTypes(
    request: GetCancellationTypesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: GetCancellationTypesResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.DeliveryService/GetCancellationTypes',
      request,
      metadata || {},
      this.methodInfoGetCancellationTypes,
      callback
    );
  }

  methodInfoGetCancellationRate = new grpcWeb.AbstractClientBase.MethodInfo(
    GetCancellationRateResponse,
    (request: GetCancellationRateRequest) => {
      return request.serializeBinary();
    },
    GetCancellationRateResponse.deserializeBinary
  );

  getCancellationRate(
    request: GetCancellationRateRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: GetCancellationRateResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.DeliveryService/GetCancellationRate',
      request,
      metadata || {},
      this.methodInfoGetCancellationRate,
      callback
    );
  }

  methodInfoGetEvidencesZipByTaskId = new grpcWeb.AbstractClientBase.MethodInfo(
    GetEvidencesZipByTaskIdResponse,
    (request: GetEvidencesByTaskIdRequest) => {
      return request.serializeBinary();
    },
    GetEvidencesZipByTaskIdResponse.deserializeBinary
  );

  getEvidencesZipByTaskId(
    request: GetEvidencesByTaskIdRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: GetEvidencesZipByTaskIdResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.DeliveryService/GetEvidencesZipByTaskId',
      request,
      metadata || {},
      this.methodInfoGetEvidencesZipByTaskId,
      callback
    );
  }

  methodInfoGetDeliveryDetailByUUID = new grpcWeb.AbstractClientBase.MethodInfo(
    GetDeliveryDetailByIdResponse,
    (request: GetDeliveryDetailByUUIDRequest) => {
      return request.serializeBinary();
    },
    GetDeliveryDetailByIdResponse.deserializeBinary
  );

  getDeliveryDetailByUUID(
    request: GetDeliveryDetailByUUIDRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: GetDeliveryDetailByIdResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.DeliveryService/GetDeliveryDetailByUUID',
      request,
      metadata || {},
      this.methodInfoGetDeliveryDetailByUUID,
      callback
    );
  }

  methodInfoSetLogArmirene = new grpcWeb.AbstractClientBase.MethodInfo(
    SetDeliveryLogArmireneResponse,
    (request: SetDeliveryLogArmireneRequest) => {
      return request.serializeBinary();
    },
    SetDeliveryLogArmireneResponse.deserializeBinary
  );

  setLogArmirene(
    request: SetDeliveryLogArmireneRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: SetDeliveryLogArmireneResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.DeliveryService/SetLogArmirene',
      request,
      metadata || {},
      this.methodInfoSetLogArmirene,
      callback
    );
  }
}
